import { Badge } from '@chakra-ui/react'
import { WhatsappLogo } from '@phosphor-icons/react'

export const WHATSAPP_GREEN = '#25D366'
const GUEST_EMAIL_SUFFIX = '@guest.wedrop.internal'

/** E-mail técnico do usuário-sombra (visitante+/wa+ @guest.wedrop.internal): nunca mostrar. */
export function isPlaceholderGuestEmail(email?: string | null): boolean {
  return String(email || '').trim().toLowerCase().endsWith(GUEST_EMAIL_SUFFIX)
}

/** "5511999998888" -> "+55 11 99999-8888". Fora do padrão BR, devolve com "+". */
export function formatWaId(waId?: string | null): string {
  const d = String(waId || '').replace(/\D/g, '')
  if (!d) return ''
  const m = d.match(/^55(\d{2})(\d{4,5})(\d{4})$/)
  return m ? `+55 ${m[1]} ${m[2]}-${m[3]}` : `+${d}`
}

export function WhatsappBadge({ size = 'sm' }: { size?: 'xs' | 'sm' }) {
  const iconSize = size === 'xs' ? 10 : 12
  return (
    <Badge
      bg={WHATSAPP_GREEN}
      color="white"
      fontSize={size === 'xs' ? { base: '9px', md: '10px' } : { base: '2xs', md: 'xs' }}
      borderRadius="full"
      px={size === 'xs' ? 1 : 1.5}
      display="inline-flex"
      alignItems="center"
      gap={0.5}
      title="Atendimento via WhatsApp oficial"
    >
      <WhatsappLogo size={iconSize} weight="fill" />
      WhatsApp
    </Badge>
  )
}
